import AutoBind from 'auto-bind'
import EventEmitter from 'events'
import each from 'lodash/each'

export default class extends EventEmitter {
  constructor ({ classes, element, elements }) {
    super()

    AutoBind(this)

    this.classes = {
      ...classes
    }

    this.selectors = {
      element,
      elements: {
        ...elements
      }
    }
  }

  create () {
    this.animations = []
    this.components = []

    this.element = this.selectors.element
      ? document.querySelector(this.selectors.element)
      : document.getElementsByTagName('body')[0]
    this.elements = {}

    each(this.selectors.elements, (selector, key) => {
      if (
        selector instanceof window.HTMLElement ||
        selector instanceof window.NodeList
      ) {
        this.elements[key] = selector
      } else if (Array.isArray(selector)) {
        this.elements[key] = selector
      } else {
        this.elements[key] = this.element.querySelectorAll(selector)

        if (this.elements[key].length === 0) {
          this.elements[key] = null
        } else if (this.elements[key].length === 1) {
          this.elements[key] = this.element.querySelector(selector)
        }
      }
    })

    this.createAnimations()
    this.createComponents()
  }

  /**
   * Animations.
   */
  createAnimations () {}

  /**
   * Components.
   */
  createComponents () {}

  /**
   * Animations.
   */

  show (url) {
    this.isVisible = true

    return Promise.resolve()
  }

  hide (url) {
    this.isVisible = false

    return Promise.resolve()
  }

  /**
   * Events.
   */

  onResize () {
    if (!this.elements.wrapper) return

    window.requestAnimationFrame((_) => {
      each(this.animations, (animation) => {
        animation.onResize && animation.onResize()
      })
      each(this.components, (component) => {
        component.onResize && component.onResize()
      })
    })
  }

  /**
   * Frames.
   */
  update () {}
}
